import React, { useState } from "react";
import TestCard from "./TestCard";
import { Button } from '@/components/ui/button';
import { Stack } from '@/components/ui/layout';
import { cn } from '@/lib/utils';

function TestCards({ onSelectTestCard }) {
  const [selectedTestCard, setSelectedTestCard] = useState([]);
  const [showPopup, setShowPopup] = useState(false);

  const testCards = [
    {
      title: "Screening Test",
      description: "Quickly assess a candidate's core skills and competencies to evaluate their suitability for the role.",
      route: "/screening",
    },
    {
      title: "Communication Test",
      description: "Evaluate a candidate's ability to communicate clearly, effectively, and professionally across different contexts and mediums.",
      route: "/communication",
    },
    {
      title: "Personality Test",
      description: "Gain insights into a candidate's personality traits to understand how they align with your team's culture.",
      route: "/personality-test",
    },
    {
      title: "Behavioral Test",
      description: "Evaluate how candidates approach workplace challenges, solve problems, and collaborate in team settings.",
      route: "/behavioral-test",
    },
    {
      title: "Personality & Behavioral Test",
      description: "Assess both a candidate's personality traits and their approach to real-world work scenarios, gaining valuable insights into how they'll fit within your team and handle challenges in the workplace.",
      route: "/all-test",
    },
    {
      title: "Coding Test",
      description: "Assess a candidate's technical proficiency by testing their coding abilities through structured challenges and real-world scenarios.",
      route: "/icoding",
    },
  ];  

  const handleSelectTestCard = (card) => {
    console.log(selectedTestCard);
    console.log(selectedTestCard.length);
    setSelectedTestCard((prevSelected) => {
      const isSelected = prevSelected.includes(card.route); // Check using the `route`
      if (isSelected) {
        return prevSelected.filter((route) => route !== card.route); // Remove if already selected
      } else {
        return [...prevSelected, card.route]; // Add route to array if not selected
      }
    });
  };

  const handleConfirmSelection = () => {
    onSelectTestCard(selectedTestCard);
    setShowPopup(false);
  };

  return (
    <div className={cn("flex flex-col h-full")}>
      <div className={cn("flex-1 overflow-y-auto space-y-4 p-4")}>
        {testCards.map((card, index) => (
          <div key={index} className={cn("cursor-pointer flex justify-center w-full")}>
            <TestCard
              title={card.title}
              description={card.description}
              icon={card.icon}
              route={card.route}
              isSelected={selectedTestCard.includes(card.route)}
              onSelect={() => handleSelectTestCard(card)}
            />
          </div>
        ))}
      </div>

      {/* ✅ Confirm Button at Bottom Right */}
      {selectedTestCard.length > 0 && (
        <div className={cn("p-4 border-t flex justify-end")}>
          <Button onClick={handleConfirmSelection}>
            Confirm Selection
          </Button>
        </div>
      )}
    </div>
  );
}

export default TestCards;